import React, { useEffect, useState } from "react";
import FeaturedImage from "../src/Components/Featured/FeaturedImage";
import WorkFlow from "../src/Components/WorkFlow/WorkFlow";
import ServiceSlider from "../src/Components/Service/ServiceSlider";
import EthicalEssence from "../src/Components/EthicalEssence/EthicalEssence";
import ClientTestimony from "../src/Components/ClientTestimony/ClientTestimony";
import ContactForm from "../src/Components/Contact/ContactForm";
import ProjectCounter from "./Components/ProjectCounter/ProjectCounter";
import whatsappimg from "./assets/whatsapp.png";
import phoneImg from "./assets/reciever.png";

const HomePage = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [message, setMessage] = useState("");

  const whatsappNumber = "+971565443552";

  const handleWhatsappClick = () => {
    setIsChatOpen(true);
  };

  const handlePhoneButton = () => {
    window.location.href = `tel:${whatsappNumber}`;
  };

  const handleSendMessage = () => {
    const text = message.trim() || "Hi I want to know more about your services";
    const url = `https://wa.me/${whatsappNumber.replace("+", "")}?text=${encodeURIComponent(
      text,
    )}`;
    window.open(url, "_blank");
  };

  // Page par aate hi 2 seconds baad popup open ho
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsChatOpen(true);
    }, 2000); // 2000 milliseconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div id="">
        <FeaturedImage />
      </div>

      {/* Phone floating button */}
      <div
        style={{
          position: "fixed",
          bottom: "70px",
          right: "20px",
          zIndex: "9999",
          height: "50px",
          width: "50px",
        }}
      >
        <img
          src={phoneImg}
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50px",
            cursor: "pointer",
          }}
          onClick={handlePhoneButton}
          alt="phoneImg"
          loading="lazy"
        />
      </div>

      {/* WhatsApp floating button */}
      <div
        style={{
          position: "fixed",
          bottom: "10px",
          right: "20px",
          zIndex: "9999",
          height: "50px",
          width: "50px",
        }}
      >
        <img
          src={whatsappimg}
          style={{
            height: "50px",
            width: "50px",
            borderRadius: "50px",
            cursor: "pointer",
          }}
          onClick={handleWhatsappClick}
          alt="whatsappimg"
          loading="lazy"
        />
      </div>

      {/* WhatsApp chat popup */}
      {isChatOpen && (
        <div
          style={{
            position: "fixed",
            bottom: "70px",
            right: "80px",
            width: "320px",
            maxWidth: "90vw",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow:
              "0 2px 10px rgba(0,0,0,0.15), 0 0 0 1px rgba(0,0,0,0.05)",
            zIndex: "10000",
            overflow: "hidden",
            fontFamily: "inherit",
          }}
        >
          {/* Header */}
          <div
            style={{
              backgroundColor: "#25D366",
              color: "#ffffff",
              padding: "10px 12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div style={{ fontSize: "14px", fontWeight: "600" }}>
                Chat with us on WhatsApp
              </div>
              <div style={{ fontSize: "12px", opacity: 0.9 }}>
                Usually replies quickly
              </div>
            </div>
            <button
              onClick={() => setIsChatOpen(false)}
              style={{
                background: "transparent",
                border: "none",
                color: "#ffffff",
                fontSize: "18px",
                cursor: "pointer",
                lineHeight: 1,
              }}
            >
              ×
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: "10px 12px", fontSize: "14px" }}>
            <div
              style={{
                backgroundColor: "#f0f0f0",
                borderRadius: "8px",
                padding: "8px 10px",
                marginBottom: "8px",
              }}
            >
              <span style={{ fontWeight: 600 }}>Hello</span>
              <div>How can we help you</div>
            </div>
            <div style={{ fontSize: "12px", color: "#999999" }}>
              This is a preview chat. When you click Send we will open WhatsApp
            </div>
          </div>

          {/* Input area */}
          <div
            style={{
              borderTop: "1px solid #e0e0e0",
              padding: "8px 10px",
              display: "flex",
              gap: "6px",
              alignItems: "center",
            }}
          >
            <input
              type="text"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write your message"
              style={{
                flex: 1,
                border: "1px solid #dddddd",
                borderRadius: "20px",
                padding: "6px 12px",
                fontSize: "13px",
                outline: "none",
              }}
            />
            <button
              onClick={handleSendMessage}
              style={{
                backgroundColor: "#25D366",
                color: "#ffffff",
                border: "none",
                borderRadius: "20px",
                padding: "6px 12px",
                fontSize: "13px",
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              Send
            </button>
          </div>
        </div>
      )}

      <div>
        <WorkFlow />
      </div>

      {/* <div>
        <ServiceSlider />
      </div> */}

      <div>
        <EthicalEssence />
      </div>

      <div>
        <ProjectCounter />
      </div>

      <div>
        <ClientTestimony />
      </div>

      <div id="contact-us">
        <ContactForm />
      </div>
    </>
  );
};

export default HomePage;
